import { render, staticRenderFns } from "./HiddenAccept.vue?vue&type=template&id=438970da&scoped=true"
import script from "./HiddenAccept.vue?vue&type=script&lang=js"
export * from "./HiddenAccept.vue?vue&type=script&lang=js"
import style0 from "./HiddenAccept.vue?vue&type=style&index=0&id=438970da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438970da",
  null
  
)

export default component.exports